define('catalogsDetailTabsView',[
  'module',
  'underscore',
  'marionette',
  'tabsViewView',
  'catalogsDetailDetailsView',
  'catalogTemplatesListView'
], function (
  Module,
  _,
  Marionette,
  TabsContainerView
) {
  'use strict';

  Module.exports = TabsContainerView.extend({
    className: 'catalogs-detail-tabs-view ' + TabsContainerView.prototype.className,
    selectedTab: 'details',

    initialize: function () {
      TabsContainerView.prototype.initialize.apply(this, arguments);
      // Preserve model and catalogSecId on options for child tabs
      this.model = this.options.model;
      this.catalogSecId = this.options.catalogSecId;

      // When catalog name changes, update tab labels to include the name
      if (this.model && this.model.on) {
        this.listenTo(this.model, 'change:name', _.bind(this.updateTabLabels, this));
      }
    },

    tabs: function () {
      return [
        {
          name: 'details',
          title: _.i18n('common.details') || 'Details',
          view: 'catalogsDetailDetailsView'
        },
        {
          name: 'templates',
          title: _.i18n('catalogs.templates') || 'Templates',
          view: 'catalogTemplatesListView'
        }
      ];
    },

    getChildViewOptions: function () {
      // Options passed to contents view (and then as viewOptions to each tab view)
      return {
        viewOptions: {
          model: this.model,
          catalogSecId: this.catalogSecId
        }
      };
    },

    updateTabLabels: function () {
      var name = this.model && this.model.getName ? this.model.getName() : '';
      var suffix = name ? (' — ' + name) : '';
      if (this.collection) {
        this.collection.each(function (m) {
          if (m.get('name') === 'details') {
            m.set('label', ( _.i18n('common.details') || 'Details') + suffix);
          }
          if (m.get('name') === 'templates') {
            m.set('label', ( _.i18n('catalogs.templates') || 'Templates') + suffix);
          }
        });
      }
    }
  });
});

